import VueRouter from "vue-router";

import routes from "./routes/routes";
import { updateActiveNavbarLinkOnNavigation } from "~/util/sidebar/sidebar";
import { handleStoreCleanupOnNavigation } from "~/util/reset_store_state/reset_store_state";
import { isVueRoute } from "./helpers";

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  // Log to history stack
  const outdatedHistory = window.routerHistory ? window.routerHistory : [];
  window.routerHistory = [...outdatedHistory, to];
  const fullPageReload = from.path === "/";

  // Reset ssr initial blade page before navigating to route.
  const activePanel = document.getElementById("active-panel");
  const initialPanel = document.getElementById("initial-panel");
  if (activePanel) activePanel.style.display = "flex";
  if (initialPanel) initialPanel.style.display = "none";

  if (fullPageReload) {
    next();
  } else {
    // Reset state of stores on navigation where needed.
    handleStoreCleanupOnNavigation(to, from);
    // Reload when going from a vue route back to blade view
    const fromVueRouteToBladeView = !isVueRoute(to.path) && isVueRoute(from.path);
    const fromBase = from.path.split("/")[1];
    const toBase = to.path.split("/")[1];

    if (fromVueRouteToBladeView || (fromBase !== toBase)) {
      window.location.href = to.path;
      return;
    }
    // Remove reloadToken from test added.
    if (window.reloadToken) window.reloadToken = undefined;
    // eslint-disable-next-line no-restricted-syntax
    for (const elt of window.document.querySelectorAll("body>.tooltip")) {
      document.body.removeChild(elt);
    }
    // Update static navbar state.
    updateActiveNavbarLinkOnNavigation(to);
    // Remove server side rendered blade page if navigating to vue route.
    if (document.getElementById("customer-page-template")) {
      document.getElementById("customer-page-template").remove();
    }

    // Reset page specific state.
    window.main.$store.commit("RESET_PAGE_INSTANCE");
    window.main.$store.commit("RESET_CATEGORY");

    next();
  }
});

export default router;
